// extracted by mini-css-extract-plugin
export default {"trustPilot":"TopBanner_trustPilot__KnO2A","topBanner":"TopBanner_topBanner__VO3Z8"};